import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {Link} from 'react-router-dom';

import CarouselMain from '../carousel/CarouselMain.js';

import noQueryImg from '../../assets/icons/examples-bg.png';

const MainPageWhatInPbl = ({ clang, data }) => {
    const verticalOrient = {
      WebkitBoxOrient: 'vertical'
    };

    const getListItem = (dataItem, index) => {
        return  <li key={index} className="main-wip__item" ref={`item${index}`}>
                    <Link to={`/about/examples/${dataItem.id}`} className="main-wip__link" title={lang[clang].title.queries_examples}>
                        <div className="main-wip__img" style={{backgroundImage: "url(" + (dataItem.better_featured_image !== null ? dataItem.better_featured_image.source_url : noQueryImg) + ")"}}></div>
                        <span className="main-wip__circle"></span>
                        <div className="main-wip__info">
                            <h3 className="main-wip__title" style={verticalOrient}>
                                {dataItem.title.rendered}
                            </h3>
                        </div>
                        <span className="main-wip__btn">
                            <span className="main-wip__btn-icon"></span>
                        </span>
                    </Link>
                </li>;
    };

    return (
        <article className="main-wip">
            <div className="main-wip__container">
                <Link className="main-wip__header" to={`/about/what-in`} dangerouslySetInnerHTML={{__html:lang[clang].main_page.what_in}}></Link>
                <div className="main-wip__carousel">
                    <CarouselMain data={data} getListItem={getListItem}/>
                </div>
                <Link to={`/about/examples`} title={lang[clang].main_page.more_queries_examples} className="main-wip__all-button">
                    {lang[clang].main_page.more_queries_examples}
                    <span className="main-wip__all-button__img"></span>
                </Link>
            </div>
        </article>
    );
};

MainPageWhatInPbl.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(MainPageWhatInPbl);



// WEBPACK FOOTER //
// ./src/components/main-page/MainPageWhatInPbl.js